import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "condition", "fieldName", "filterFamily", "getReferencedObjectType", "getSpecialOptionsForReferenceType", "InputComponent", "onChange", "resolver", "onBlur"];
import { memo, useCallback } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message

import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import styled from 'foundations-theming/utils';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import MultiValueEditorButton, { BUTTON_WIDTH_PIXELS } from './MultiValueEditorButton';
import { STRING } from 'customer-data-objects/property/PropertyTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getIsMulti = (fieldName, operator) => operator.constructor.isIterableField(fieldName);
const GrowingContainer = styled.div.withConfig({
  displayName: "FilterOperatorValueInput__GrowingContainer",
  componentId: "sc-1y0bc8o-0"
})(({
  widthOffset
}) => ({
  flexGrow: 1,
  maxWidth: `calc(100% - ${widthOffset}px)`
}));
const FilterOperatorValueInput = _ref => {
  var _condition$field, _condition$field2, _condition$field3, _condition$field4, _condition$field5, _condition$field6;
  let {
      disabled,
      condition,
      fieldName = 'value',
      filterFamily,
      getReferencedObjectType,
      getSpecialOptionsForReferenceType,
      InputComponent,
      onChange,
      resolver,
      onBlur
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const handleChange = useCallback((
  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'nextValue' implicitly has an 'any... Remove this comment to see the full error message
  {
    target: {
      value: nextValue
    }
  }, options) => {
    if (options && options.hasClickedUpdate) {
      onChange(syntheticEvent(condition.set(fieldName, nextValue).set('hasTimezones', false)));
    } else {
      onChange(syntheticEvent(condition.set(fieldName, nextValue)));
    }
  }, [condition, fieldName, onChange]);
  const specialOptions = getSpecialOptionsForReferenceType(getReferencedObjectType(filterFamily, condition), filterFamily);
  const isMulti = getIsMulti(fieldName, condition);
  const isSimpleString = ((_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.type) === STRING && !((_condition$field2 = condition.field) !== null && _condition$field2 !== void 0 && _condition$field2.externalOptionsReferenceType);
  const showMultiEditorButton = isMulti && isSimpleString;
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsx(GrowingContainer, {
      widthOffset: showMultiEditorButton ? BUTTON_WIDTH_PIXELS : 0,
      children: /*#__PURE__*/_jsx(InputComponent, Object.assign({}, rest, {
        field: condition.field,
        fieldType: (_condition$field3 = condition.field) === null || _condition$field3 === void 0 ? void 0 : _condition$field3.type,
        filterFamily: filterFamily,
        multi: isMulti,
        numberDisplayHint: (_condition$field4 = condition.field) === null || _condition$field4 === void 0 ? void 0 : _condition$field4.numberDisplayHint,
        onBlur: onBlur,
        onChange: handleChange,
        options: (_condition$field5 = condition.field) === null || _condition$field5 === void 0 ? void 0 : _condition$field5.options,
        resolver: resolver,
        showCurrencySymbol: !!((_condition$field6 = condition.field) !== null && _condition$field6 !== void 0 && _condition$field6.showCurrencySymbol),
        specialOptions: specialOptions,
        value: condition.get(fieldName),
        condition: condition,
        disabled: disabled
      }))
    }), showMultiEditorButton && /*#__PURE__*/_jsx(MultiValueEditorButton, {
      disabled: disabled,
      onChange: evt => handleChange(evt)
      //@ts-expect-error `get` returns `unknown` type
      ,
      value: condition.get(fieldName)
    })]
  });
};
export default /*#__PURE__*/memo(FilterOperatorValueInput);